import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook-icon",
  "use": "facebook-icon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"facebook-icon\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.28733 18.3334V10.9715H5.83337V7.9041H8.28733V5.45014C8.28733 2.91459 9.89283 1.66675 12.1548 1.66675C13.2382 1.66675 14.1695 1.74773 14.4406 1.78331V4.43359L12.8719 4.4342C11.6419 4.4342 11.3548 5.01885 11.3548 5.87651V7.9041H14.4222L13.8087 10.9715H11.3548L11.4039 18.3334\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol